export function addDays(date: Date, days: number, keepTime: boolean = false) {
  return keepTime
  ? new Date(date.getFullYear(), date.getMonth(), date.getDate() + days, date.getHours(), date.getMinutes(), date.getSeconds())
    : new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
}

export function isWeekend(date: Date) {
  return date.getDay() === 6 || date.getDay() === 0;
}
